module.exports = __webpack_public_path__ + "media/A_music_loop.59f444ca.mp3";